<template>
    <div :style="headStyle">
        <div style="display:flex;">
            <div class="y-line" type="vertical"></div>
            <div style="display: inline-block;vertical-align: middle;position: relative;text-align: center !important;border-radius: 10px;margin: 10px 0 0 10px;font-size:20px;">{{ title }}<span style="font-size:16px;left:16px;color: #aaa;">{{ title2 }}</span></div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
  export default {
    name: "XdhmCard",
    props: {
      title: {
        type: String,
        default: ''
      },
      title2:{
        type: String,
        default: ''
      },
      headStyle:{
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped>
    .y-line{
        display:inline-block;
        width:6px;
        vertical-align:middle;
        position:relative;
        height: 22px;
        text-align: center !important;
        background:#40a9ff;
        border-radius: 10px;
        margin:13px 0 0 10px;
    }
</style>